import { STATUS_OPTIONS } from '../constants';
import { StatusMapping } from '@/models/EntityType';

// Map each status value to its configured display order index.
const STATUS_ORDER = STATUS_OPTIONS.reduce<Record<string, number>>(
  (acc, { value }, index) => {
    acc[value] = index;
    return acc;
  },
  {},
);

// Return a new stages array sorted by configured status order.
export const sortByStatusOrder = (stages: StatusMapping[]): StatusMapping[] => {
  const sortedStages = [...stages].sort(
    (a, b) =>
      (STATUS_ORDER[a.status] ?? Number.MAX_SAFE_INTEGER) -
      (STATUS_ORDER[b.status] ?? Number.MAX_SAFE_INTEGER),
  );
  return sortedStages;
};
